import { render, staticRenderFns } from "./Apparatus.vue?vue&type=template&id=60d27c6e&"
import script from "./Apparatus.vue?vue&type=script&lang=js&"
export * from "./Apparatus.vue?vue&type=script&lang=js&"
import style0 from "./Apparatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports